
<div class="message-confirm" *ngIf="isDeliveryDropshippingConfirmation">
  <h2 class="title">Дякуємо!</h2>
  <b>
    Ваше замовлення № {{ data.data.order_id }} прийняте
  </b>
  <p class="text-center">Відвантаження товару здійснюється по <b>повній передоплаті</b></p>
  <b class="text-center alert">
    Прийом платежів здійснюється за реквізитами які вказані в меню -> реквізити.<br>Після оплати необхідно повідомляти
    про оплату на сайті!
  </b>
  <ng-container *ngIf="data.data.global_settings_status_otgrujaem == 'on' && (data.data.status_otgrujaem || (data.data.settings_status_otgrujaem && data.data.settings_status_otgrujaem == '1')) else unpaidConditions">
    <b class="text-center alert">
      Курсова різниця - ризики замовника!
    </b>
  </ng-container>
  <ng-template #unpaidConditions>
    <b class="text-center alert">
      Неоплачене замовлення на вказану дату відправки, буде автоматично розформоване.
    </b>
  </ng-template>
  <p class="text-center">Оформлене замовлення <span class="alert">до {{ data.data.tiltime }} </span> відправляється в
    <span class="alert">той же день</span>
  </p>
  <p class="text-center">Замовлення оформлені <span class="alert">після {{ data.data.tiltime }} </span> будуть
    відправлені <span class="alert">наступного робочго дня</span>
  </p>

  <div *ngIf="newScheme" class="content">
    <p class="size">1. Наклейку і реєстр ви завантажили під час оформлення - склад надрукує їх сам, надсилати листом
      не потрібно.</p>
    <p class="size">2. Номер ТТН система розпізнає з наклейки і впише в замовлення сама - перевірте розпізнаний номер:
      Меню - замовлення - графа номер декларації. Якщо номер не розпізнався, графа виділена рожевим кольором - впишіть
      його там.</p>
  </div>
  <div *ngIf="!newScheme" class="content">
    <p class="size">1. У вашому особистому кабінеті перевізника створіть ТТН та обов’язково вкажіть внутрішній номер відправлення (№ замовлення) м. Київ, відділення відправки НП №5; Делівері №1.</p>
    <p class="size">2. Створюєте один реєстр на ТТН-ки Нової Пошти, Делівері.</p>
    <p class="size">2.1. Скачайте в PDF форматі: маркування 100 * 100 типу "зебра" PDF і реєстр в альбомному
      форматі.</p>
    <p class="size">2.2. Наклейки робляться у відповідності з кількістю місць. У разі, якщо ви не знаєте точну кількість
      місць для вашого замовлення, чекайте повідомлення з точною кількістю місць: <br>- у телеграм бот (треба бути підписаним на
      @MaslotochkacomBot). <br>- Меню, замовлення, колонка тип доставки. Це стосується лише замовлень, де кількість місць більше одного!</p>
    <p class="size">3. Відправляєте маркування і реєстр на <span class="alert">dropmt@ukr.net</span>. ВАЖЛИВО (!)В темі
      листа вказати (!): "Наклейка і № замовлення".</p>
    <p class="size">4. ОБОВ‘ЯЗКОВО! Після оформлення замовлення прописати номер ТТН в замовленнях: Меню - замовлення -
      графа номер декларації - буде виділена рожевим кольором.</p>
  </div>
  <div class="row items-center form_data"
       *ngIf="parseFloat(data.data.calcdebt_summa) > 1 && (
                    parseFloat(data.data.calcdebt_summa) > parseFloat(data.data.delay_summa)
                    || data.data.delay_from && (data.data.delay_from < data.data.delay_days)
              )"
  >
    <div class="column"></div>
    <div class="column shrink textright">
      <b class="comment">
        Прострочена заборгованість!<br>
        Відвантаження вашого замовлення можливе після виконання договірних зобов'язань щодо оплати.
      </b>
    </div>
    <div class="column"></div>
  </div>
  <a routerLink="/" class="button">Ознакомлен</a>
</div>
